import React, { useContext } from "react";
import { HeaderContext } from "../../../../../../store/context/header-context";
import ARROW from "../../../../../../assets/images/vector/Layout/Header/arrow-right.svg";
import { ANALYTICS_PROPS } from "../../../content/index.content";
import TrackedLink from "../../../../../Analytics/TrackedLink";
import "../../../index.scss";

const Link = (props) => {
  const {
    title,
    subtitle,
    href,
    action,
    label,
    category,
    extraTitle,
    isLink,
    isBlank,
  } = props;
  const { t } = useContext(HeaderContext);
  return (
    <TrackedLink
      path={href}
      action={action ?? title}
      target={isBlank}
      label={label}
      category={category ?? ANALYTICS_PROPS.category}
      isLink={isLink}
      classes="GCL-H-V-C-L"
    >
      <div className="GCL-H-V-C-L__title">
        {typeof title === "string" ? t(title) : title}
        {extraTitle && (
          <span className="GCL-H-V-C-L__extraTitle">
            {t("See all videos")}
            <img src={ARROW} alt="" />
          </span>
        )}
      </div>
      <div className="GCL-H-V-C-L__subtitle">
        {typeof subtitle === "string" ? t(subtitle) : subtitle}
      </div>
    </TrackedLink>
  );
};

export default Link;
